// src/components/Navbar.jsx
import React from 'react';
import PropTypes from 'prop-types';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useScrollTrigger,
  Slide,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

const navLinks = [
  { label: 'Home',      href: '/' },
  { label: 'For Dropshipping',  href: 'drop' },
  { label: 'About',     href: 'about' },
  { label: 'Services',  href: 'services' },
  // { label: 'Market',  href: '/shop' },
  { label: 'Free Website',  href: 'webgen' },
  { label: 'Free Image Editor',   href: 'photoedit' },
  { label: 'Careers',   href: 'career' },
  { label: 'Projects',  href: 'projects' },
  { label: 'Contact',   href: 'contact' },
];

function ElevationScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger({ disableHysteresis: true, threshold: 0 });
  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
    sx: {
      backgroundColor: trigger ? 'background.paper' : 'transparent',
      transition: 'background-color 0.3s',
    },
  });
}

ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
};

export default function Navbar({ onToggleTheme, darkMode }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const handleDrawerOpen  = () => setDrawerOpen(true);
  const handleDrawerClose = () => setDrawerOpen(false);

  const drawer = (
    <Box sx={{ width: 240 }} role="presentation" onClick={handleDrawerClose}>
      <List>
        {navLinks.map(({ label, href }) => (
          <ListItem key={label} disablePadding>
            <ListItemButton component="a" href={href}>
              <ListItemText primary={label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <ElevationScroll>
        <AppBar position="sticky" color="transparent" sx={{ backdropFilter: 'blur(10px)' }}>
          <Toolbar>
            <Box
                component="img"
                src="/logo.jpg"
                alt="LEMDA Logo"
                sx={{ height: 40, mr: 1 }}
              />
            <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700 }}>
              <Box component="span" sx={{ color: 'primary.main' }}>LEMDA</Box> (PVT) LTD
            </Typography>

            {/* Desktop Links */}
            {!isMobile && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {navLinks.map(({ label, href }) => (
                  <Button
                    key={label}
                    component="a"
                    href={href}
                    color="inherit"
                    sx={{ textTransform: 'none', fontWeight: 600 }}
                  >
                    {label}
                  </Button>
                ))}

                {/* Theme toggle */}
                <IconButton onClick={onToggleTheme} color="inherit">
                  {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
                </IconButton>
              </Box>
            )}

            {/* Mobile Menu Button */}
            {isMobile && (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton onClick={onToggleTheme} color="inherit">
                  {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
                </IconButton>
                <IconButton edge="end" onClick={handleDrawerOpen} color="inherit">
                  <MenuIcon />
                </IconButton>
              </Box>
            )}
          </Toolbar>
        </AppBar>
      </ElevationScroll>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerClose}
        ModalProps={{ keepMounted: true }}
      >
        {drawer}
      </Drawer>
    </>
  );
}
